import { render, staticRenderFns } from "./ImageHolder.vue?vue&type=template&id=78fb57fb&"
import script from "./ImageHolder.vue?vue&type=script&lang=js&"
export * from "./ImageHolder.vue?vue&type=script&lang=js&"
import style0 from "./ImageHolder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports